module.exports = __webpack_public_path__ + "media/impact-2.c7164c5c.webm";